/* eslint-disable @typescript-eslint/no-explicit-any */

import { IconType } from '../index';

const IconEucalipto = (props: any) => {
  return (
    <svg
      width="auto"
      height="26"
      viewBox="0 0 19 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.81512 4.11406C4.5195 1.46106 6.8285 0 9.31687 0C11.8052 0 14.1142 1.46106 15.8186 4.11406C17.4403 6.63825 18.3334 9.97575 18.3334 13.5118C18.3334 17.0478 17.4403 20.3853 15.8186 22.9094C14.331 25.2251 12.3826 26.6324 10.2566 26.9529V32H8.37731V26.9528C6.25119 26.6323 4.30287 25.225 2.81519 22.9094C1.1935 20.3852 0.300436 17.0477 0.300436 13.5117C0.300436 9.97569 1.1935 6.63825 2.81512 4.11406ZM4.39625 21.8936C5.50981 23.6269 6.89756 24.7155 8.37725 25.0407V22.3393L4.91906 18.8811L6.24787 17.5522L8.37725 19.6816V15.9636H10.2565V19.6816L12.3859 17.5522L13.7147 18.8811L10.2565 22.3393V25.0407C11.7362 24.7155 13.124 23.6269 14.2375 21.8936C15.6669 19.6688 16.4541 16.6919 16.4541 13.5117C16.4541 10.3314 15.6669 7.35469 14.2375 5.12981C12.8908 3.03363 11.1433 1.87925 9.31687 1.87925C7.49044 1.87925 5.74287 3.03363 4.39625 5.12981C2.96687 7.35469 2.17969 10.3315 2.17969 13.5118C2.17969 16.692 2.96687 19.6688 4.39625 21.8936Z"
        fill={props.color}
      />
    </svg>
  );
};

IconEucalipto.defaultProps = {
  color: 'black',
} as IconType;

export default IconEucalipto;
